import { render, staticRenderFns } from "./import-whitelist.vue?vue&type=template&id=78f7b5bd&scoped=true&"
import script from "./import-whitelist.vue?vue&type=script&lang=js&"
export * from "./import-whitelist.vue?vue&type=script&lang=js&"
import style0 from "./import-whitelist.vue?vue&type=style&index=0&id=78f7b5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7b5bd",
  null
  
)

export default component.exports